import { FormStatus } from "@/shared/modules/typescript-trustapi-client/models";
import { Options, Prop, Vue } from "vue-property-decorator";

@Options({})
export default class AccessDenied extends Vue {


  @Prop({ default: false })
  private modalOpened!: boolean;

  @Prop({ default: null })
  private formStatus!: FormStatus;

  @Prop({ default: false })
  private typeA!: boolean;

  @Prop({ default: false })
  private typeB!: boolean;

  @Prop({ default: false })
  private typeC!: boolean;

  @Prop({ default: "" })
  private firstNameProp!: string;

  @Prop({ default: "" })
  private lastNameProp!: string;

  created(): void {
    console.log(this.formStatus, this.typeA, this.firstNameProp, this.lastNameProp);
  }

  mounted() {
    if (!this.modalOpened) {
      document.body.classList.add('modal-open');
    }
  }

  beforeUnmount() {
    if (!this.modalOpened) {
      document.body.classList.remove('modal-open');
    }
  }

  private closeModal(): void {
    this.$emit('close');
  }

  get firstName(): string {
    return this.typeA ? this.firstNameProp : this.formStatus?.updatingBy?.firstName ?? '';
  }

  get lastName(): string {
    return this.typeA ? this.lastNameProp : this.formStatus?.updatingBy?.lastName ?? '';
  }

}

